import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useState } from "react";
import RequestControllerRedux from "../../contexts/RequestController.js";
import TabelaRedux from "../../contexts/Tabela.js";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import LoadingBar from "../LoadingBar/LoadingBar.js";
import ModalCadastro from "../ModalCadastro/ModalCadastro.tsx";
import "../ModalVincular/ModalVincular.css";
import SelectEmbarqueV2 from "../SelectEmbarqueV2/SelectEmbarqueV2.js";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	texto: string;
	open: boolean;
	listaUsuarios: any;
	referenciaId: string;
	referenciaItem: string;
	id: string;
	onClose: () => void;
	onClick: () => void;
	setUsuarioId: (e) => void;
	setNomeUsuario: (e) => void;
}

function ModalVincular(props: SimpleDialogProps) {
	const { tabelaRedux } = useContext(TabelaRedux);

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const [valuesSelect, setValuesSelect] = useState<any>([]);

	const { onClose, open, onClick } = props;

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClick();
	};

	const [loadingSelectMotivo, setLoadingSelectMotivo] = useState(false);

	useEffect(() => {
		setLoadingSelectMotivo(true);
		setTimeout(() => {
			setLoadingSelectMotivo(false);
		}, 1000);
	}, [props.listaUsuarios]);

	const [openCadastroMotivo, setOpenCadastroMotivo] = useState(false);

	const handleCloseCadastroMotivo = () => {
		if (idAtual) {
			setOpenCadastroMotivo(false);
			setDadosRequestControllerRedux("Close Motivo");
		} else {
			setOpenCadastroMotivo(false);
			setDadosRequestControllerRedux("Close Motivo");
		}
	};

	const [openCadastroMotivoOnTime, setOpenCadastroMotivoOnTime] =
		useState(false);

	const handleCloseCadastroMotivoOnTime = () => {
		if (idAtual) {
			setOpenCadastroMotivoOnTime(false);
			setDadosRequestControllerRedux("Close Motivo");
		} else {
			setOpenCadastroMotivoOnTime(false);
			setDadosRequestControllerRedux("Close Motivo");
		}
	};

	const [idAtual, setIdAtual] = useState(0);

	const [disable, setDisable] = useState(false);

	useEffect(() => {
		if (tabelaRedux?.row?.motivoOnTime) {
			setValuesSelect((current) => ({
				...current,
				motivo: {
					value: tabelaRedux.row.motivoOnTime.motivo,
					label: tabelaRedux.row.motivoOnTime.motivo,
					id: tabelaRedux.row.motivoOnTime.id,
				},
			}));
		} else {
			setValuesSelect((current) => ({
				...current,
				motivo: {
					value: null,
					label: null,
					id: null,
				},
			}));
		}
	}, [tabelaRedux]);

	const clearMotivo = () => {
		props.setUsuarioId(null);
		props.setNomeUsuario(null);
		setValuesSelect((current) => ({
			...current,
			motivo: "",
		}));
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-vincular">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent className="content-vincular">
						<DialogContentText id="alert-dialog-description">
							{loadingSelectMotivo ? (
								<div className="coluna-modalmotivo">
									<LoadingBar />
								</div>
							) : (
								<div className="coluna-modalmotivo">
									<div>
										<p className="input-label-emb">Usuários:</p>
										<SelectEmbarqueV2
											classeCss={250}
											onChange={(e) => {
												props.setUsuarioId(e.id);
												props.setNomeUsuario(e.value);
												setValuesSelect((current) => ({
													...current,
													motivo: e,
												}));
											}}
											clearSelection={clearMotivo}
											value={valuesSelect.motivo}
											id={props.id}
											titulo="Empresa"
											dadosSelect={props.listaUsuarios}
											referenciaId={props.referenciaId}
											referenciaItem={props.referenciaItem}
											info={false}
										/>
									</div>
								</div>
							)}
						</DialogContentText>
					</DialogContent>
					<DialogActions className="action-vincular">
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="Vincular"
							cor="#0946B8"
							onClick={handleClick}
						/>
						<CustomButtonV2
							classCss="custom-button-cancelar"
							classText="button-texto-cancelar"
							titulo="Cancelar"
							cor="#0946B8"
							onClick={handleClose}
						/>
					</DialogActions>
				</div>
			</Dialog>
			<div>
				<ModalCadastro
					titulo="Cadastro"
					tituloConfirmar="OK"
					cadastroMotivo="sim"
					open={openCadastroMotivo}
					idAtual={idAtual}
					desabilitar={disable}
					onClose={handleCloseCadastroMotivo}
				/>
				<ModalCadastro
					titulo="Cadastro"
					tituloConfirmar="OK"
					cadastroMotivoOnTime="sim"
					open={openCadastroMotivoOnTime}
					idAtual={idAtual}
					desabilitar={disable}
					onClose={handleCloseCadastroMotivoOnTime}
				/>
			</div>
		</div>
	);
}

export default ModalVincular;
